import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit.settings', {
        url: '/settings',
        component: 'editHardTokenSettings',
       
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/settings/hard-token-settings.state.js